import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Circle, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import icon from 'leaflet/dist/images/marker-icon.png';
import icon2x from 'leaflet/dist/images/marker-icon-2x.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';
import { MapPin } from "lucide-react";

// Fix the default icon issue by merging options
L.Icon.Default.mergeOptions({
  iconRetinaUrl: icon2x,
  iconUrl: icon,
  shadowUrl: shadow,
});

// Business location
const BUSINESS_LOCATION = {
  lat: 43.5897315,
  lng: -80.5737911,
};
const SERVICE_RADIUS_KM = 25;

const ServiceAreaMap = ({ height = "400px", showUserLocation = false, userLocation = null }) => {
  const [mapReady, setMapReady] = useState(false);

  useEffect(() => {
    setMapReady(true);
  }, []);

  if (!mapReady) {
    return (
      <div 
        className="bg-slate-100 rounded-2xl flex items-center justify-center" 
        style={{ height }}
      >
        <div className="text-slate-500">Loading map...</div>
      </div>
    );
  }

  return (
    <div className="rounded-2xl overflow-hidden shadow-lg" style={{ height }}>
      <MapContainer
        center={[BUSINESS_LOCATION.lat, BUSINESS_LOCATION.lng]}
        zoom={9}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
        attributionControl={false}
      >
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* Service Area Circle */}
        <Circle
          center={[BUSINESS_LOCATION.lat, BUSINESS_LOCATION.lng]}
          radius={SERVICE_RADIUS_KM * 1000}
          pathOptions={{
            color: "#0EA5E9",
            fillColor: "#0EA5E9",
            fillOpacity: 0.1,
            weight: 2,
          }}
        />
        
        {/* Business Location Marker */}
        <Marker
          position={[BUSINESS_LOCATION.lat, BUSINESS_LOCATION.lng]}
          //icon={createCustomIcon()}
        >
          <Popup>
            <div className="text-center p-2">
              <p className="font-bold text-sky-700">Scrubbles Laundry & More</p>
              <p className="text-sm text-slate-600">7-112 Oriole Parkway</p>
              <p className="text-sm text-slate-600">Elmira, ON N3B 1C5</p>
              <p className="text-sm text-sky-600 mt-2">519-210-9274</p>
            </div>
          </Popup>
        </Marker>

        {/* User Location Marker */}
        {showUserLocation && userLocation && (
          <Marker position={[userLocation.lat, userLocation.lng]}>
            <Popup>
              <div className="text-center p-2">
                <p className="font-semibold">Your Location</p>
              </div>
            </Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
};

export default ServiceAreaMap;
